import {useState, useEffect} from 'react';
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Communautes from '../assets/Communautes.png';
import Communautes2 from '../assets/Communautes2.png';
import Communautes3 from '../assets/Communautes3.png';
import Communautes4 from '../assets/Communautes4.png';

function EntrepriseScreen() {

  React.useEffect(() => {
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = "https://analytics.preprod.qalmo.fr/js/container_LnaaM1aY.js";
    s.parentNode.insertBefore(g, s);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const images = [Communautes, Communautes2, Communautes3, Communautes4];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastInteractionTime >= 7000) {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
        setLastInteractionTime(Date.now());
      }
    }, 1000);
  
    return () => clearInterval(interval);
  }, [lastInteractionTime, images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="min-h-screen bg-[url('../assets/fond.png')] bg-repeat bg-top bg-auto flex flex-col items-center justify-start space-y-12 py-12 px-4 bg-gray-50 font-fraunces">
      <Header />
      <div className="flex flex-col-reverse md:flex-row items-center justify-center gap-12 w-full max-w-7xl lg:pt-14">
        <div className="bg-white shadow-lg rounded-2xl p-8 w-full md:w-[30%] min-h-[200px] flex flex-col items-center justify-center text-center">
          <h3 className="text-xl font-bold mb-4">Fédérez autour de votre activité</h3>
          <p className="text-base text-gray-700 text-justify"> Créez un sentiment d’appartenance fort grâce à une communauté engagée. Vos utilisateurs deviennent vos meilleurs ambassadeurs, prolongeant la vie de votre activité bien au-delà de vos murs. </p>
        </div>
        <div className="relative w-full md:w-[40%]">
          <img src={images[currentIndex]} alt={currentIndex} className="w-full h-auto" />
          <button onClick={goToPrevious} className="absolute left-3 top-1/2 transform -translate-y-1/2 bg-white w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full shadow-lg hover:bg-gray-100" aria-label="Previous image">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 md:w-8 md:h-8 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          </button>
          <button onClick={goToNext} className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-white w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full shadow-lg hover:bg-gray-100" aria-label="Next image">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 md:w-8 md:h-8 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
        <div className="bg-white shadow-lg rounded-2xl p-8 w-full md:w-[30%] min-h-[200px] flex flex-col items-center justify-center text-center">
          <h3 className="text-xl font-bold mb-4">Renforcez l’engagement utilisateur</h3>
          <p className="text-base text-gray-700 text-justify"> Encouragez vos membres à interagir régulièrement et à s’investir dans votre univers. En favorisant des échanges fréquents et du contenu partagé, vous stimulez une participation active et durable. </p>
        </div>
      </div>
      <Link to="/contact">
        <button className="mt-6 px-8 py-4 bg-[#000B23] text-white text-lg font-semibold rounded-full shadow-lg hover:bg-gray-800 transition duration-300 -mt-12">
          Nous contacter
        </button>
      </Link>
    </div>
  );
}

export default EntrepriseScreen;
